import { useCallback, useState } from "react";

export function useShare() {
  const [toast, setToast] = useState("");

  const showToast = useCallback((message: string) => {
    setToast(message);
    window.setTimeout(() => setToast(""), 2400);
  }, []);

  const copyLink = useCallback(
    async (path: string) => {
      const url = `${window.location.origin}${__BASE_PATH__}${path}`.replace(/([^:]\/)\/+/g, "$1");
      try {
        await navigator.clipboard.writeText(url);
        showToast("链接已复制，快去分享吧");
      } catch {
        showToast("复制失败，请手动复制地址栏链接");
      }
    },
    [showToast],
  );

  const shareTo = useCallback(
    (platform: "weibo" | "x" | "facebook", path: string, text: string) => {
      const url = `${window.location.origin}${__BASE_PATH__}${path}`.replace(/([^:]\/)\/+/g, "$1");
      const encodedUrl = encodeURIComponent(url);
      const encodedText = encodeURIComponent(text);
      let target = "";
      if (platform === "weibo") {
        target = `https://service.weibo.com/share/share.php?url=${encodedUrl}&title=${encodedText}`;
      } else if (platform === "x") {
        target = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}`;
      } else {
        target = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
      }
      window.open(target, "_blank", "noopener,noreferrer");
    },
    [],
  );

  return { toast, copyLink, shareTo, showToast };
}